import { useTranslation } from "react-i18next";
import type { Namespace, NamespaceKeys } from "./types";

type TranslationOptions = Record<string, unknown>;
type NamespaceList = readonly [Namespace, ...Namespace[]];

export function useStrictNamespaceTranslation<Ns extends Namespace>(ns: Ns) {
  const { t, i18n } = useTranslation(ns);

  const tStrict = (key: NamespaceKeys[Ns], options?: TranslationOptions) =>
    t(key as string, options);

  return { t, tStrict, i18n };
}

export function useStrictMultiNamespaceTranslation<Ns extends NamespaceList>(
  namespaces: Ns,
) {
  const { t, i18n } = useTranslation(namespaces);

  // Accept strict typed keys while allowing gradual migration of legacy keys.
  const tNs = <N extends Ns[number]>(
    namespace: N,
    key: NamespaceKeys[N] | string,
    options?: TranslationOptions,
  ) => t(key as string, { ns: namespace, ...(options ?? {}) });

  return { t, tNs, i18n };
}
